/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { Locale } from '../locale/Locale';
import { LocaleKeys } from '../locale/LocaleKeys';
import { AppError } from './AppError';

export class SignInError extends AppError {
    TAG: string = 'SignInError';

    protected title: string = Locale.getString(LocaleKeys.SIGN_IN_ERROR_OVERLAY_TITLE);

    protected description: string = '';

    protected type: string = '';

    constructor(message: string, code: string) {
        super(code, message);
    }

    public getDescription(): string {
        return this.description;
    }

    public getTitle(): string {
        return this.title;
    }

    public getType(): string {
        return this.type;
    }
}
